module.exports = __webpack_public_path__ + "img/icons-corretora.3fa8821c.svg";